<template>
  <div class="app">
    <!-- <notify-test></notify-test> -->
    <version-checker :PFX="PROJ_PFX" :bundleVersion="appInfo.version"></version-checker>
    <div class="app__preheader" ref="preheader">
      <preheader></preheader>
    </div>
    <LoaderBar></LoaderBar>
    <div class="app__main"
         :class="{'nav-open': $sidebar.showSidebar, 'app__main--disableSelect': $store.state.appInterface.disableSelect}">
      <transition name="fade" mode="out-in">
        <router-view :class="{ 'blur': visibleReloginOnFly}"></router-view>
      </transition>
      <transition name="fade" mode="out-in">
        <relogin-on-fly style="animation-duration: 0.15s"
                        v-if="visibleReloginOnFly"
                        @login-canceled="onReloginCancel()"
                        @login-success="onReloginSuccess()"
        ></relogin-on-fly>
      </transition>
    </div>
    <v-style v-for="(style,uid) in $store.state.appInterface.styles" :key="uid">
      {{style.query}} {
        <template v-for="(value,param) in style.params">{{param}}: {{value}};
        </template>
      }
    </v-style>
  </div>
</template>

<script>
  import config from '@/config'
  import Cookies from 'js-cookie'
  import ReloginOnFly from './components/ReloginOnFly/ReloginOnFly.vue'
  import auth from 'src/services/auth'
  import localStorageTransport from './services/localStorageTransport'
  import Preheader from './components/Preheader/Preheader'
  import LoaderBar from './components/LoaderBar/LoaderBar'
  // import NotifyTest from './notifyTest.vue'
  // Loading some plugin css asynchronously

  import packagejson from '@/lib/packagejson'

  import versionChecker from '@/plugins/VersionChecker/VersionChecker.vue'
  import {
    PROJ_PFX,
    LANG,
    PAGE_TITLE,
    PAGE_DESCRIPTION,
  } from '@/constants'
  import globvars from '@/lib/globvars'
  export default {
    name: 'App',
    components: {
      versionChecker,
      Preheader,
      ReloginOnFly,
      LoaderBar
      // NotifyTest
    },
    watch: {
      $route () {
        setTimeout(() => {
          this.$root.$emit('resetScroll')
          this.$root.$emit('focusOnContent')
        }, 150)
      },
      user () {
        this.connectWs()
      },
      bodyMaximized (val) {
        if (val) {
          document.querySelector('body').classList.add('bodyMaximized');
        } else {
          document.querySelector('body').classList.remove('bodyMaximized');
        }
      }
    },
    data () {
      return {
        PROJ_PFX,
        visibleReloginOnFly: false,
        appInfo: packagejson.getKeys()
      }
    },
    onIdle () {
      this.relogin();
    },
    onActive () {},
    metaInfo() {
      return {
        title: this.seoPageTitle,
        meta: [
          {
            name: 'description',
            content: this.seoPageDescription
          }
        ]
      }
    },
    methods: {
      onResize: _.debounce(function () {
        this.defineCSSVars();
      }, 200),
      defineCSSVars () {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      },
      onReloginCancel () {
        this.visibleReloginOnFly = false
      },
      onReloginSuccess () {
        this.visibleReloginOnFly = false
        this.$root.$emit('on-login')
      },
      relogin () {
        if (this.$route.path !== '/login') {
          this.visibleReloginOnFly = true
          this.$store.dispatch('user/logout')
          this.$root.$emit('relogin')
        }
      },
      makeAppInfoLog () {
        console.log('name:', this.appInfo.name)
        console.log('version:', this.appInfo.version)
        for (const key in this.appInfo) {
          // console.log(key + ': ', this.appInfo[key])
        }
      },
      connectWs () {
        const Ws = globvars.get('ws')
        const token = auth.readToken()
        const uid = this.$store.state.user.user.id
        if (token && uid) {
          Ws.connect(token, uid)
        }
      }
    },
    computed: {
      seoPageTitle() {
        const configPageTitle = config(PAGE_TITLE)

        if (configPageTitle) {
          return configPageTitle;
        }

        return 'Student Notification System';
      },
      seoPageDescription() {
        const configPageDescription = config(PAGE_DESCRIPTION)

        if (configPageDescription) {
          return configPageDescription;
        }

        return 'Ultimate All-in-One Hub for Effective Mass Notification in Universities'
      },
      user () {
        return this.$store.state.user.user
      },
      bodyMaximized () {
        return this.$store.state.bodyMaximized
      }
    },
    async mounted () {
      const redirectPage = sessionStorage.getItem('redirectPage');

      if (redirectPage) {
        sessionStorage.removeItem('redirectPage');
        this.$router.push(redirectPage);
      }

      window.addEventListener('resize', this.onResize);
      this.defineCSSVars();

      this.$nextTick(() => {
        const lang = Cookies.get('lang_checked') || config(LANG) || 'en';

        this.$store.commit('setLang', lang);
      })

      if (this.bodyMaximized) {
        document.querySelector('body').classList.add('bodyMaximized');
      }
      this.connectWs()
      this.makeAppInfoLog()
      localStorageTransport.on('login', async () => {
        await this.$store.dispatch('user/loadUser', true);

        this.visibleReloginOnFly = false
        if (this.$route.name === 'login') {
          this.$router.push('/')
        }
      })
      localStorageTransport.on('logout', () => {
        this.$router.push('/login')
      })

      this.$bus.$on('relogin-on-fly:request', () => {
        this.visibleReloginOnFly = true
      })

      this.$bus.$on('close-relogin-on-fly', () => {
        this.visibleReloginOnFly = false
      })

      this.$bus.$on('errorUserMessage', (userMessage) => {
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.error'),
          message: userMessage,
          type: 'error',
          offset: 75
        })
      })
      window.addEventListener('focus', () => {
        this.$root.$emit('on-window-focus')
      });
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
  }
</script>
<style lang="scss">
  $animationDuration: 0.24s;
  @import "~vue2-animate/src/sass/vue2-animate.scss";

  @import "./assets/fonts/Roboto/stylesheet";

  @import "./assets/styles/scss/typography";
  // library imports
  @import './assets/sass/paper-dashboard.scss';
  @import './assets/sass/element_variables.scss';
  @import './assets/sass/demo.scss';
  @import './assets/sass/print.scss';

  .el-select-dropdown__list .el-select-dropdown__item {
    max-width: 238px;
    height: auto;
    line-height: 1.2;
    padding-top: 10px;
    padding-bottom: 10px;
    overflow: visible;
    white-space: normal;
    text-overflow: unset;

    .bodyMaximized & {
      max-width: 344px;
    }
  }

  .active-form__col, .user-list-filters__filter {
    .el-select__tags-text {
      display: inline-block;
      max-width: 165px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

    .bodyMaximized & {
      max-width: 271px;
    }
    }
    .el-tag__close.el-icon-close {
      margin-top: -16px;
    }
  }

  html, body {
    height: 100%;
    overflow: hidden;
  }

  .app {
    display: flex;
    flex-flow: column;
    height: 100%;
    overflow: hidden;

    &__main {
      flex: 1;
      display: flex;
      overflow: auto;

      &--disableSelect {
        * {
          user-select: none;
          -webkit-user-select: none;
        }
      }
    }
  }

  .notifications.vue-notifyjs {
    .notification-list-move {
      transition: transform 0.3s, opacity 0.4s;
    }

    .notification-list-item {
      display: inline-block;
      margin-right: 10px;

    }

    .notification-list-enter-active, .notification-list-leave-active {
      transition: opacity 0.4s;
    }

    .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */
    {
      opacity: 0;
    }
  }

  .el-tabs__nav-scroll {
    overflow: auto;
  }

  .blur {
    -webkit-filter: blur(8px);
    -moz-filter: blur(8px);
    filter: blur(8px);
    filter: progid:DXImageTransform.Microsoft.Blur(pixelRadius=8);
    overflow: hidden;
    transform: translateZ(0);
  }

</style>